import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { GameLogic } from '../../../Logic/GameLogic';
import { AnimationContents } from '../../../../AnimationContents';
import {
    MiniGameModel,
    MiniGameTypeEnum,
} from '../../../Models/Game/MiniGameModel';
import { BonusTypeEnum } from '../../../Models/Game/BonusModel';

export class MiniGameController extends AnimationBaseController {
    $model: MiniGameModel;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic
    ) {
        super('MiniGameController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'mini_game_container',
            modelWatch: {
                pos: (pos: [number, number]) => {
                    this.x = pos[0];
                    this.y = pos[1];
                },
                selected: (selected: boolean) => {
                    if (selected) {
                        this.gotoAndStop(this.$model.type + '_over');
                    } else {
                        this.gotoAndStop(this.$model.type);
                    }
                },
                played: (value: boolean) => {
                    this.setType(
                        this.$model.visible && this.$model.active
                            ? this.$model.type
                            : MiniGameTypeEnum.none
                    );
                },
                type: (miniGameType: MiniGameTypeEnum) => {
                    this.setType(
                        this.$model.visible && this.$model.active
                            ? this.$model.type
                            : MiniGameTypeEnum.none
                    );
                },
                active: (value: boolean) => {
                    this.setType(
                        this.$model.visible && this.$model.active
                            ? this.$model.type
                            : MiniGameTypeEnum.none
                    );
                },
                visible: (value: boolean) => {
                    this.setType(
                        this.$model.visible && this.$model.active
                            ? this.$model.type
                            : MiniGameTypeEnum.none
                    );
                },
            },
        };
    }

    protected onInitialize(): void {
        this.setType(this.$model.type);
    }

    protected onUpdate(frameRate: number) {
        const global = this.display.parent.toGlobal(
            new PIXI.Point(this.display.x, this.display.y)
        );

        this._gameLogic.setMiniGameScreenPosition(this.$model.type, [
            global.x,
            global.y,
        ]);
    }

    private setType(type: MiniGameTypeEnum): void {
        this.x = this.$model.pos[0];
        this.y = this.$model.pos[1];

        this.gotoAndStop(type);

        if (type !== MiniGameTypeEnum.none) {
            this.gotoAndStopByQuery(
                `${this.$model.key}`,
                !this.$model.active
                    ? 'played'
                    : this.$model.played
                    ? 'played'
                    : 'not_played',
                false
            );
        }

        this.setScaleByQuery('dummy', 0, 0);
        this.setScaleByQuery(`${this.$model.key}.teleport`, 0, 0);

        if (this.$model.type != MiniGameTypeEnum.none) {
            this.getCurrentPointsPaths((x, y, paths, shapeContainer, shape) => {
                shapeContainer.visible = false;
            }, `${this.$model.key}.collisions`);

            this.$model.width = this.display.width;
            this.$model.height = this.display.height;
        }
    }
}
